export default __webpack_public_path__ + "static/media/left.8a627bd1.png";